import { ActionContext } from 'vuex'
import apiAdminEnseigne from '@/api/admin/enseigne'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IEnseigneState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloDbEnseigne } from '@/models/alodb/AloDbEnseigne'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class EnseigneAction {
  public [types.ENSEIGNE_REQUEST](context: ActionContext<IEnseigneState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.ENSEIGNE_REQUEST)
      apiAdminEnseigne
        .getEnseignes()
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const enseigneArray = resp.data.data as AloBaseArray<AloDbEnseigne>
            context.commit(types.ENSEIGNE_SUCCESS, enseigneArray.items)
            resolve(enseigneArray.items)
          } else {
            context.commit(types.ENSEIGNE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.ENSEIGNE_ERROR)
          reject()
        })
    })
  }

  public [types.ENSEIGNE_ENSURE_LIST](context: ActionContext<IEnseigneState, IRootState>) {
    if (context.state.enseignes.length == 0) {
      return context.dispatch(types.ENSEIGNE_REQUEST)
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.state.enseignes)
      })
    }
  }

  public [types.ENSEIGNE_SELECT_DETAIL](context: ActionContext<IEnseigneState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      const enseigne = context.getters.enseignesById[itemId] as AloDbEnseigne
      if (enseigne) {
        if (enseigne.detailLoaded) {
          context.commit(types.ENSEIGNE_SELECT_DETAIL, enseigne)
          resolve(enseigne)
        } else {
          context.dispatch(types.ENSEIGNE_SELECT_DETAIL_REQUEST, itemId).then(ens => {
            context.commit(types.ENSEIGNE_SELECT_DETAIL, ens)
            resolve(ens)
          })
        }
      } else {
        const newEnseigne = new AloDbEnseigne()
        context.commit(types.ENSEIGNE_SELECT_DETAIL,newEnseigne)
        resolve(newEnseigne)
      }
    })
  }

  public [types.ENSEIGNE_SELECT_DETAIL_REQUEST](context: ActionContext<IEnseigneState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.ENSEIGNE_SELECT_DETAIL_REQUEST, itemId)
      apiAdminEnseigne
        .getEnseigne(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const enseigne = resp.data.data as AloDbEnseigne
            context.commit(types.ENSEIGNE_SELECT_DETAIL_SUCCESS, enseigne)
            context.commit(types.ENSEIGNE_SELECT_DETAIL, enseigne)
            resolve(enseigne)
          } else {
            context.commit(types.ENSEIGNE_SELECT_DETAIL_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(() => {
          context.commit(types.ENSEIGNE_SELECT_DETAIL_ERROR)
          reject()
        })
    })
  }

  public [types.ENSEIGNE_SAVE_REQUEST](context: ActionContext<IEnseigneState, IRootState>) {
    return new Promise((resolve, reject) => {
      const tryRedirect = !context.state.modifiedAdmEnseigne.id
      context.commit(types.ENSEIGNE_SAVE_REQUEST, context.state.modifiedAdmEnseigne.ENS_LIBELLE)
      apiAdminEnseigne
        .saveEnseigne(context.state.modifiedAdmEnseigne)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const enseigne = resp.data.data as AloDbEnseigne
            context.commit(types.ENSEIGNE_SELECT_DETAIL_SUCCESS, enseigne)
            context.commit(types.ENSEIGNE_SELECT_DETAIL, enseigne)
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:enseigne.ENS_LIBELLE}))          
            if (tryRedirect && router.app.$route.name === 'NewEnseigne')
              router.push({ name: 'EditEnseigne', params: { itemid: enseigne.id!.toString() } })
            resolve(enseigne)
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.ENSEIGNE_SAVE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.ENSEIGNE_SAVE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.ENSEIGNE_UPDATE_MODIFIED_ADM](
    context: ActionContext<IEnseigneState, IRootState>,
    newProperties: Object
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.ENSEIGNE_UPDATE_MODIFIED_ADM, newProperties)
      resolve(context.state.modifiedAdmEnseigne)
    })
  }

  public [types.ENSEIGNE_CANCEL_MODIFIED_ADM](context: ActionContext<IEnseigneState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.ENSEIGNE_SELECT_DETAIL, context.state.originalAdmEnseigne)
      resolve(context.state.modifiedAdmEnseigne)
    })
  }

  public [types.ENSEIGNE_UPDATE_FILTER_ADM](context: ActionContext<IEnseigneState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.ENSEIGNE_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }
}

export default util.classToObject(EnseigneAction)
